import { FAQ } from "../static_faqs/types";

export const tataDigitalFaqs: FAQ[] = [
  {
    question: "What is this offer about?",
    answer:
      "This is a special offer for select Tata Neu HDFC Bank Credit Card holders. Eligible customers will receive a communication from Tata Digital (via SMS, WhatsApp, or Email) containing a unique coupon code. This code can be redeemed on the Hubble platform for discounts on select gift cards.",
  },
  {
    question: "Who is eligible for the offer?",
    answer:
      "Eligibility is determined by Tata Digital based on internal criteria. If you’ve received a coupon code from Tata Digital via SMS, WhatsApp, or Email, you are eligible for the offer.",
  },
  {
    question: "How do I redeem the coupon code?",
    answer:
      "1. Log in using your registered mobile number\n2. Enter the coupon code you received from Tata Digital\n3. Choose a gift card and select desired denomination\n4. Complete your purchase with Tata Neu HDFC Bank Credit Card to avail the offer",
  },
  {
    question: "How will I receive the gift card after purchase?",
    answer:
      "Once the redemption is successful, your selected gift card will be sent to you via SMS, WhatsApp, or Email.",
  },
  {
    question: "Where can I use the coupon code?",
    answer:
      "The coupon code can only be used on the Tata Digital Hubble Rewards Platform: https://tatadigital.hubble-rewards.com",
  },
  {
    question: "How long is my coupon code valid?",
    answer:
      "Validity details are mentioned in the communication you received from Tata Digital. Expired codes cannot be reissued or extended.",
  },
  {
    question: "Can I transfer my coupon code to someone else?",
    answer:
      "No. The coupon code is for your personal use only and cannot be transferred.",
  },
  {
    question:
      "Can I club this offer with other Hubble discounts or promotions?",
    answer:
      "No, this coupon code cannot be combined with any other promotions or discounts on the Hubble platform.",
  },
  {
    question: "Who do I contact if I face issues while redeeming the coupon?",
    answer:
      "For any redemption issues or platform-related queries, reach out to us at: support@myhubble.money. Please note: Tata Digital is not responsible for technical issues or redemption failures.",
  },
  {
    question: "Is my personal data shared with Tata Digital?",
    answer:
      "No. Your personal information is not shared by Hubble with Tata Digital. Similarly, Tata Digital does not share your identifiable information with us. If you choose to redeem the offer, you are voluntarily sharing your information with us for processing the gift card purchase.",
  },
  {
    question: "Can the offer terms change?",
    answer:
      "Yes. Tata Digital may modify, cancel, or withdraw the offer at its discretion, without prior notice.",
  },
];
